import { FC } from 'react';

// Components
import { CountryFlag } from '@velinsi/smp-widgets-ui/src/molecules/CountryFlag/CountryFlag';

// Utils
import { getIconAsBgImage, classNames } from '@sportal365/smp-widget-utils';

// Types
import { INormalizedTennisRankingRow } from '../../../types';
import { RankingColumnTypes } from '../../../../../../packages/constants/tennis';

interface Props {
  row: INormalizedTennisRankingRow;
  handleParticipantClick: (id: string | number, name: string) => void;
}

export const RankingTableCell: FC<Props> = ({ row, handleParticipantClick }) => {
  const { athlete, link, urlTarget, isHighlighted, rank } = row;
  const pointsColumn = row.columns.find((col) => col.type.code === RankingColumnTypes.POINTS);
  const pointsValue = pointsColumn ? pointsColumn.value : '';

  return (
    <a
      href={link}
      target={urlTarget}
      onClick={() => handleParticipantClick(athlete.id, athlete.name)}
      className='table-row-link contents decoration-none outline-none hover:decoration-none active:decoration-none focus:decoration-none'
    >
      <tr
        className={classNames({
          'bg-highLighted': row.isHighlighted,
          'bg-rowBackgroundColor': !row.isHighlighted,
          'table-row-data border-b border-solid border-b-rowBorderColor flex items-center justify-between w-full text-hiContrast h-14 xxs:px-3':
            true,
        })}
      >
        <td
          className={classNames({
            'ranking-table-cell-rank flex justify-center content-center sticky left-0 w-52': true,
            'bg-highLighted': isHighlighted,
            'bg-rowBackgroundColor': !isHighlighted,
          })}
        >
          <span className='rank-data w-9 text-center flex items-center justify-center font-semibold'>{rank}</span>
          <div className='flex items-center w-full text-inherit decoration-none'>
            <img
              src={athlete?.assets?.headshot?.url ?? getIconAsBgImage('participant-placeholder')}
              alt={athlete.name}
              className='w-[42px] h-[42px] object-cover flex-shrink-0 mr-1'
            />
            <span className='athlete-name-data max-w-[170px] text-sm overflow-hidden text-ellipsis whitespace-nowrap block font-semibold'>
              {athlete.name}
            </span>
          </div>
        </td>
        <td
          className={classNames({
            'ranking-table-cell-nationality text-hiContrast text-4 whitespace-nowrap text-ellipsis overflow-hidden xxs:w-12 xs:w-20 sm:w-24 md:w-40 flex items-center xxs:justify-center md:justify-start':
              true,
            'bg-highLighted': isHighlighted,
            'bg-rowBackgroundColor': !isHighlighted,
          })}
        >
          <CountryFlag country={athlete.country} />
          <span className='xxs:hidden md:block md:ml-2'>{athlete.country?.name}</span>
        </td>

        <td
          className={classNames({
            'ranking-table-cell-points text-center text-hiContrast text-4 whitespace-nowrap md:w-24 xxs:w-12': true,
            'bg-highLighted': isHighlighted,
            'bg-rowBackgroundColor': !isHighlighted,
          })}
        >
          {pointsValue}
        </td>
      </tr>
    </a>
  );
};
